import store from "@/store/index.js";
import { createRouter, createWebHistory } from "vue-router";
import NotFound from "../views/NotFound.vue";
import News from "../views/news/index.vue";

// Define routes
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/homeView/index.vue"),
    meta: {
      title: "首页 - 易游网",
      description: "易游网",
      keywords: "易游网,管理平台,首页",
      showGameDetailFooter: true,
    },
  },
  {
    path: "/news/:id.html",
    name: "News",
    component: News,
    meta: {
      title: "新闻详情_易游网_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租",
      description: "易游网 - 新闻详情页，了解最新游戏资讯",
      keywords: "新闻详情,易游网,游戏资讯",
    },
  },
  {
    path: "/mails",
    name: "Mails",
    component: () => import("../views/mails/index.vue"),
    meta: {
      title: "邮件管理 - 易游网",
      description: "易游网 - 邮件管理页面，查看和管理邮件",
      keywords: "邮件管理,易游网,邮件列表",
      requiresAuth: true,
    },
  },
  {
    path: "/mails/detail/:id?",
    name: "MailDetail",
    component: () => import("../views/mails/MailDetail.vue"),
    meta: {
      title: "邮件详情 - 易游网",
      description: "易游网 - 邮件详情页面，查看邮件完整内容",
      keywords: "邮件详情,易游网,邮件内容",
      requiresAuth: true,
    },
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("../views/detail/index.vue"),
    meta: {
      title: "游戏详情_易游网_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租",
      description: "易游网 - 游戏详情页，提供详细的游戏账号信息",
      keywords: "游戏详情,易游网,游戏账号",
      showGameDetailFooter: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      isHiddLayout: true,
      title: "登录_易游网_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租",
      description: "易游网 - 账号登录页面，安全便捷的登录方式",
      keywords: "账号登录,易游网,用户登录",
    },
  },
  {
    path: "/duihuan",
    name: "DuihuanLogin",
    component: () => import("../views/duihuan/DuihuanLogin.vue"),
    meta: {
      isHiddLayout: true,
      title: "兑换中心 - 易游网",
    },
  },
  {
    path: "/duihuan/account",
    name: "DuihuanAccount",
    component: () => import("../views/duihuan/DuihuanAccount.vue"),
    meta: {
      isHiddLayout: true,
      title: "我的账号 - 兑换中心 - 易游网",
    },
  },
  {
    path: "/payment/account/:gameId/:accountId",
    name: "Payment",
    component: () => import("../views/payment/confirm.vue"),
    meta: {
      title: "订单支付 - 易游网",
      description: "易游网 - 订单支付页面",
      keywords: "订单支付,易游网,游戏账号",
      requiresAuth: true,
      isHiddFooter: true,
    },
  },
  {
    path: "/payment/official/:gameId/:skuId",
    name: "OfficialPayment",
    component: () => import("../views/payment/confirm.vue"),
    meta: {
      title: "精选商家订单支付 - 易游网",
      description: "易游网 - 精选商家订单支付页面",
      keywords: "精选商家,订单支付,易游网",
      requiresAuth: true,
      isHiddFooter: true,
    },
  },
  {
    path: "/payment/scanqrcode/:orderNumber",
    name: "PaymentScanQrcode",
    component: () => import("../views/payment/scanqrcode.vue"),
    meta: {
      title: "订单支付 - 易游网",
      description: "易游网 - 订单支付页面",
      keywords: "订单支付,易游网,游戏账号",
      requiresAuth: true,
      isHiddFooter: true,
    },
  },
  {
    path: "/payment/result/:orderNumber",
    name: "PaymentResult",
    component: () => import("../views/payment/result.vue"),
    meta: {
      title: "订单支付结果 - 易游网",
      description: "易游网 - 订单支付结果页面",
      keywords: "订单支付结果,易游网,游戏账号",
      requiresAuth: true,
      isHiddFooter: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/center/layout/index.vue"),
    children: [
      {
        path: "",
        redirect: "/profile/account",
      },
      {
        path: "/profile/account",
        name: "ProfileAccount",
        component: () => import("../views/center/account/index.vue"),
      },
      {
        path: "/profile/order",
        name: "ProfileOrder",
        component: () => import("../views/center/order/index.vue"),
      },
      {
        path: "/profile/wallet",
        name: "ProfileWallet",
        component: () => import("../views/center/wallet/index.vue"),
      },
      {
        path: "/profile/resale",
        name: "ProfileResale",
        component: () => import("../views/center/resale/index.vue"),
      },
    ],
  },
  {
    path: "/gameStore",
    name: "Store",
    component: () => import("../views/gameStore/index.vue"),
    meta: {
      title: "游戏商店_易游网_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租",
      description: "易游网 - 游戏商店页面，提供游戏账号购买和销售",
      keywords: "游戏商店,易游网,游戏账号",
      showGameDetailFooter: true,
    },
  },
  {
    path: "/zkGame",
    name: "zkGame",
    component: () => import("../views/zkGame/index.vue"),
    meta: {
      title: "史低游戏_易游网_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租",
      description: "易游网 - 史低游戏页面，提供游戏账号购买和销售",
      keywords: "史低游戏,易游网,游戏账号",
      showGameDetailFooter: true,
    },
  },
  {
    path: "/helpCenter",
    name: "HelpCenter",
    component: () => import("../views/helpcenter/index.vue"),
    meta: {
      title: "帮助中心_易游网_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租",
      description: "易游网 - 帮助中心页面，提供常见问题解答",
      keywords: "帮助中心,易游网,常见问题",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "页面未找到",
      description: "页面未找到",
      keywords: ",404,页面未找到",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard - 统一权限验证逻辑
router.beforeEach(async (to, from, next) => {
  // Update document title
  document.title = to.meta.title || "易游网";

  // 登录和找回密码页面不需要验证
  const noAuthRoutes = ["/login", "/404"];

  if (noAuthRoutes.includes(to.path)) {
    next();
    return;
  }

  // 如果权限模块未初始化，先获取权限
  // if (!store.getters['permission/isPermissionInitialized'] && !store.getters['permission/isPermissionLoading']) {
  //     try {
  //         await store.dispatch('permission/fetchPermissions');
  //     } catch (error) {
  //         console.error('获取权限失败:', error);
  //         // 权限获取失败时，允许访问基本页面
  //         next();
  //         return;
  //     }
  // }

  // // 检查是否有权限访问当前路径
  // try {
  //     const hasPermission = await store.dispatch('permission/checkPagePermission', to.path);

  //     if (!hasPermission) {
  //         // 如果没有权限，跳转到403页面
  //         next('/403');
  //         return;
  //     }
  // } catch (error) {
  //     console.error('检查页面权限失败:', error);
  //     // 权限检查失败时，允许访问
  //     next();
  //     return;
  // }

  next();
});

export default router;
